import { render, staticRenderFns } from "./SMSTokenPage.vue?vue&type=template&id=07bf0b42&scoped=true&"
import script from "./SMSTokenPage.vue?vue&type=script&lang=js&"
export * from "./SMSTokenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf0b42",
  null
  
)

export default component.exports